"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reducers = require("../../redux/reducers");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../utils/constants");
var _actions = require("../../redux/actions");
var _MultiChartContainer = require("./MultiChartContainer");
var _sagas = _interopRequireDefault(require("../../redux/sagas"));
var _hooks = require("../../hooks");
var _ChartParams = require("../../features/provider/ChartParams");
const _excluded = ["isDynamicHeight"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const MultiLineChartWrap = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    equipmentId = null,
    equipmentType = null,
    devicesPDId = null,
    className = ''
  } = _ref;
  const chartId = "chart_".concat(equipmentId, "_").concat(equipmentType);
  const dispatch = (0, _reactRedux.useDispatch)();
  const isPrediction = false;
  (0, _react.useEffect)(() => {
    return () => dispatch((0, _actions.removeActiveChartData)());
  }, []);
  (0, _react.useEffect)(() => {
    if (devicesPDId) dispatch((0, _actions.setDisplayNameIDList)({
      chartId,
      data: devicesPDId
    }));
  }, [devicesPDId]);
  (0, _hooks.useGetChartData)({
    chartId,
    devicesForChartRequest: {
      [equipmentType]: {
        [equipmentId]: devicesPDId
      }
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_MultiChartContainer.MultiChartContainer, {
    chartId: chartId,
    isPrediction: isPrediction,
    equipmentType: equipmentType,
    equipmentId: equipmentId
  }));
});
var _default = _ref2 => {
  let {
      isDynamicHeight
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  (0, _paulCorePackage.useInjectStore)({
    key: _constants.packageKey,
    reducer: {
      charts: _reducers.charts,
      devices: _reducers.devices
    },
    saga: _sagas.default
  });
  return /*#__PURE__*/_react.default.createElement(_ChartParams.ChartParamsProvider, {
    isDynamicHeight: isDynamicHeight
  }, /*#__PURE__*/_react.default.createElement(MultiLineChartWrap, props));
};
exports.default = _default;